import "Data/ServerSource";
/** @namespace GIS.Data */
NS("GIS.Data");

/**
 * GIS.Data.Projections source
 * @class
 * @extends Data.ServerSource
 */
GIS.Data.Projections = Class(Data.ServerSource, /** @lends GIS.Data.Projections.prototype */ {
    url: "GIS/Web/Projections/",

    fields: [
        { name: "id", title: "id" }, // int
        { name: "name", title: "name" }, // string
        { name: "code", title: "code" }, // int
        { name: "codename", title: "codename" }, // string
        { name: "proj4", title: "proj4" }, // string
        { name: "wkt", title: "wkt" }, // string
        { name: "extent", title: "extent" }, // double[]
        { name: "enabled", title: "enabled" },

        { name: "createddatetime", title: "createddatetime" }, // string
        { name: "modifieddatetime", title: "modifieddatetime" }, // string
        { name: "creator", title: "creator" }, // json
        { name: "modifier", title: "modifier" }, // json
    ]
});
